module.exports = __webpack_public_path__ + "img/sold-out.165b255.png";